import './App.css';
import About from './Pages/About/About';
import Header from './Pages/Header/Header';
import Home from './Pages/Home/Home';
import Skills from './Pages/Skills/Skills';
import React from 'react';
import FremWork from './Pages/FremWork/FremWork';
import AnimatedCursor from 'react-animated-cursor';
import Service from './Pages/Service/Service';
import Contact from './Pages/Contact/Contact';
// import Loadding from './Pages/Loadding';

function App() {
  // window.onscroll()

  // const loadding =()=>{
  //   return  ;
  //   console.log('loadding')
  // }



  return (
    <div  className="App overflow-hidden" >
      {/* <Loadding></Loadding> */}
      <Header></Header>
      <Home></Home>
      <About></About>
      <Skills></Skills>
      <FremWork></FremWork>
      <Service></Service>
      <Contact></Contact>
      <AnimatedCursor color='22, 241, 106'  innerSize={20}
      outerSize={10} />
    </div>
  );
}

export default App;
